import properties from '../../constants/Properties';
import modeType from '../../constants/ModeConstants';
import configuration from '../../constants/Configuration';
import appParameters from '../utils/AppParameters';
import fullScreenManager from '../utils/FullScreenManager';
import dragManager from '../utils/DragManager';
import platformDetection from '../../components/utils/PlatformDetection';
import audioEditorUtils from '../../components/audioEditor/utils/AudioEditorUtils';
import apiServiceUtils from './ApiServiceUtils';

const canvasScale = {
    getScaleProperties (windowWidth, windowHeight, accordionWidth, mode = modeType.EDITOR) {
        var verticalTopGap = properties.CANVAS_VERTICAL_TOP_PADDING;
        var verticalBottomGap = properties.CANVAS_VERTICAL_BOTTOM_PADDING;
        const horizontalGap = properties.CANVAS_HORIZONTAL_PADDING;
        var navigationBarHeight = 0;

        var isVideoEditor = (mode == modeType.VIDEO_EDITOR);
        var isAudioEditor = (mode == modeType.AUDIO_EDITOR);

        if (isVideoEditor) {
            mode = modeType.PREVIEW;
        }

        if (platformDetection.isIOSApp())
            navigationBarHeight = properties.CLIPART_BUTTON_HEIGHT;

        if (appParameters.getMode() == modeType.PLAYER || mode == modeType.PREVIEW) {
            verticalTopGap = 0;
            verticalBottomGap = 0;

            if (appParameters.getMode() == modeType.PLAYER)
                navigationBarHeight = 0;
        } else {
            navigationBarHeight = navigationBarHeight + apiServiceUtils.getNoInternetConnectionAlertHeight();
        }

        if (platformDetection.isIOS() == true)
            verticalTopGap = 0;

        let browserWidth = 0;
        let slideViewHeight = 0;
        let recordingMenuHeight = 0;
        var mainMenuWidth = 0;
        var mainResizeButtonWith = 0;

        if (mode == undefined || mode == modeType.EDITOR || mode == modeType.AUDIO_EDITOR) {
            browserWidth = accordionWidth;
            slideViewHeight = properties.SLIDE_VIEWER_TOP_LINE_HEIGHT + properties.SLIDE_VIEWER_TOP_GAP + properties.SLIDE_VIEWER_LIST_HEIGHT + properties.SLIDE_VIEWER_BOTTOM_GAP;

            if (mode == modeType.EDITOR)
                mainResizeButtonWith = properties.MAIN_RESIZE_BUTTON_WIDTH;

            mainMenuWidth = properties.MAIN_MENU_WIDTH + mainResizeButtonWith;

            if (isAudioEditor)
                slideViewHeight = slideViewHeight + audioEditorUtils.getAudioEditorHeight();

            recordingMenuHeight = properties.RECORDING_MENU_HEIGHT;
        } else {
            if (isVideoEditor)
                browserWidth = accordionWidth;

            if (fullScreenManager.isFullScreenMode())
                slideViewHeight = 0;
            else
                slideViewHeight = properties.PREVIEW_HEIGHT;
        }

        const freeWidth = windowWidth - 2 * horizontalGap - browserWidth - mainMenuWidth;
        const freeHeight = windowHeight - verticalBottomGap - verticalTopGap - slideViewHeight - recordingMenuHeight - navigationBarHeight;
        const scaleX = freeWidth / configuration.CANVAS_WIDTH;
        const scaleY = freeHeight / configuration.CANVAS_HEIGHT;
        const scale = Math.min(scaleX, scaleY);

        const left = (configuration.CANVAS_WIDTH * scale - configuration.CANVAS_WIDTH) / 2;
        const top = (configuration.CANVAS_HEIGHT * scale - configuration.CANVAS_HEIGHT) / 2;

        let canvasProperties = {};

        canvasProperties.scale = scale;

        if (scaleX == scale) {
            canvasProperties.left = left;
            canvasProperties.top = top + (freeHeight - configuration.CANVAS_HEIGHT * scale) / 2 + navigationBarHeight;

            canvasProperties.topX = horizontalGap;

            if (platformDetection.isIOS() && fullScreenManager.isFullScreenMode())
                canvasProperties.topY = (freeHeight - configuration.CANVAS_HEIGHT * scale - properties.PREVIEW_HEIGHT) / 2; // on IOS the control bar will be always visible
            else
                canvasProperties.topY = (freeHeight - configuration.CANVAS_HEIGHT * scale) / 2 + navigationBarHeight;
        } else {
            canvasProperties.left = left + (freeWidth - configuration.CANVAS_WIDTH * scale) / 2;
            canvasProperties.top = top + verticalTopGap + navigationBarHeight;

            canvasProperties.topX = (freeWidth - configuration.CANVAS_WIDTH * scale) / 2;
            canvasProperties.topY = verticalTopGap + navigationBarHeight;
        }

        dragManager.scaleProperties = canvasProperties;

        return canvasProperties;
    },
    getPrintScaleProperties(windowWidth, windowHeight) {
        const freeWidth = windowWidth;
        const freeHeight = windowHeight;
        const scaleX = freeWidth / configuration.CANVAS_WIDTH;
        const scaleY = freeHeight / configuration.CANVAS_HEIGHT;
        const scale = Math.min(scaleX, scaleY);

        const left = (configuration.CANVAS_WIDTH * scale - configuration.CANVAS_WIDTH) / 2;
        const top = (configuration.CANVAS_HEIGHT * scale - configuration.CANVAS_HEIGHT) / 2;

        let canvasProperties = {};

        canvasProperties.scale = scale;

        if (scaleX == scale) {
            canvasProperties.left = left;
            canvasProperties.top = top + (freeHeight - configuration.CANVAS_HEIGHT * scale) / 2;

            canvasProperties.topX = 0;
            canvasProperties.topY = (freeHeight - configuration.CANVAS_HEIGHT * scale) / 2;
        } else {
            canvasProperties.left = left + (freeWidth - configuration.CANVAS_WIDTH * scale) / 2;
            canvasProperties.top = top;

            canvasProperties.topX = (freeWidth - configuration.CANVAS_WIDTH * scale) / 2;
            canvasProperties.topY = 0;
        }

        return canvasProperties;
    }
};

export default canvasScale;



/** WEBPACK FOOTER **
 ** ./src/components/utils/CanvasScaleUtils.js
 **/